export default __webpack_public_path__ + "static/media/black-lock.23669e11.svg";